module.exports = __webpack_public_path__ + "assets/img/Seniors-NZ-Content-Marketing-w540.be89796e.webp";